import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "15",
      cy: "12",
      r: "10",
      fill: "#eb001b"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "25",
      cy: "12",
      r: "10",
      fill: "#f79e1b"
    }, null, -1),
    _createElementVNode("path", {
      d: "M20 3.34a10 10 0 0 1 0 17.32a10 10 0 0 1 0-17.32z",
      fill: "#ff5f00"
    }, null, -1)
  ]))]))
}
export default { render: render }